import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';
import type { Company } from '@/pages/CompanyReport/components/SimilarCompanies/Components/Tile';
import { GridViewOptions } from '@/pages/CompanyReport/constants/constants';
export const getIdeanameBySection = (section: CompanyReportSection) => {
  const SECTIONS_IDEANAME_MAP = {
    valuation: 'potentially-undervalued-companies',
    future: 'high-growth-potential-companies',
    past: 'sustainable-track-record',
    health: 'healthy-companies',
    dividend: 'top-dividend-stocks',
  };

  return SECTIONS_IDEANAME_MAP[section];
};

export const getTopCompanies = (
  companies: Company[],
  quantity: number,
  currentCompanyId: string
) => {
  return companies
    .filter(
      (company) =>
        company.companyId.toLowerCase() !== currentCompanyId.toLowerCase()
    )
    .slice(0, quantity);
};

export type SectionGridViewMap = {
  [K in CompanyReportSection]?: GridViewOptions;
};

export const getGridViewOptionIdBySection = (section: CompanyReportSection) => {
  const SECTIONS_GRID_VIEW_ID_MAP: SectionGridViewMap = {
    valuation: GridViewOptions.GRID_VIEW_POTENTIALLY_UNDERVALUED,
    future: GridViewOptions.GRID_VIEW_HIGH_GROWTH,
    past: GridViewOptions.GRID_VIEW_STRONG_PAST_PERFORMING,
    health: GridViewOptions.GRID_VIEW_HEALTHY,
    dividend: GridViewOptions.GRID_VIEW_DIVIDEND_NEW,
  };

  return SECTIONS_GRID_VIEW_ID_MAP[section];
};
